module.exports = __webpack_public_path__ + "static/img/questionnaire2.1584c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/questionnaire2.png
// module id = 9TBa
// module chunks = 1